import styled, { css } from "styled-components";
import { Collapse, Space } from "antd";

const { Panel } = Collapse;

export const CustomCollapseArea = styled(Space)`
    &&& {
        padding-top: 10px;
        ${(props) =>
          props.horizontal &&
          css`
            .ant-collapse {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;

              .ant-collapse-item {
                min-width: 200px;
                border-bottom: none;
              }
            }
          `}

      ${({ filterDirection, areFiltersAvailable }) => `
      border-bottom: ${
        filterDirection === "horizontal" && areFiltersAvailable
          ? "1px solid lightgrey"
          : "none"
      };
      
    ${
      filterDirection === "horizontal" &&
      css`
        .ant-collapse-item-active {
          .ant-checkbox-group {
            overflow-y: hidden !important;
          }

          .ant-collapse-content-box {
            padding: 0;
          }
        }
      `
    }`}
`;

export const FiltersWrapper = styled(Collapse)`
  ${({ filterDirection }) => `
    ${
      filterDirection === "horizontal" &&
      css`
        display: flex;

        position: relative;

        .ant-collapse-item {
          border: none !important;
          position: relative;
        }

        .ant-collapse-item-active {
          z-index: 5;
          background-color: #fff;
        }

        .ant-collapse-content-active {
          position: absolute;
          width: max-content;

          .ant-form-item-control-input-content div {
            overflow: hidden;
          }

          .ant-space {
            display: grid;
            grid-template-columns: auto auto auto auto;
            padding: 24px 8px;
            background-color: #fff;

            .ant-space-item {
              padding: 0 15px;
            }
          }
        }

        .ant-collapse-content:not(.ant-collapse-content-active) {
          display: none;
        }
      `
    }
  `}
`;

export const CustomPanel = styled(Panel)`
  &&& {
    z-index: 5;
    margin: 8px 0;
    border-bottom: 1px solid #d7d7d7;
    @media only screen and (max-width: 767px) {
      transition: none !important;
    }
    .ant-form-item {
      margin-bottom: 6px;
    }
    @media only screen and (max-width: 767px) {
      .ant-collapse-content {
        height: 0 !important;
      }
    }

    .ant-collapse-header {
      ${(props) =>
        props.showLabel &&
        css`
          pointer-events: none;
          padding-bottom: 0;
          .ant-collapse-expand-icon {
            display: none;
          }
        `}
    }
  }
`;

export const CustomHeader = styled.div`
  position: relative;
  .anticon {
    position: absolute;
    top: 17px;
    left: 10px;
    display: none;

    @media only screen and (max-width: 767px) {
      display: block;
    }
  }

  h3 {
    width: 100;
    text-align: center;
    text-transform: uppercase;
    font-size: 18px;
    padding: 14px 0;
    border-bottom: 1px solid #d7d7d7;
    display: none;

    @media only screen and (max-width: 767px) {
      display: block;
    }
  }
`;

export const ContentPanel = styled.div`
  background: #fff;

  .ant-form-item {
    @media only screen and (max-width: 767px) {
      padding: 10px 16px;
    }
  }

  .ant-checkbox-wrapper .ant-checkbox-input {
    position: absolute;
  }

  @media only screen and (max-width: 767px) {
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    height: 100vh;
    -webkit-animation: slide-in-right 0.4s cubic-bezier(0.8, 0.6, 0.3, 1);
    animation: slide-in-right 0.4s cubic-bezier(0.8, 0.6, 0.3, 1);
    z-index: 88;
    display: block;
  }
`;

export const FooterActions = styled.div`
  display: none;
  width: 100%;
  position: fixed;
  bottom: 18px;
  z-index: 899;

  .buttons {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 15px 20px;
    border-top: 1px solid #cecece;
  }

  button,
  p {
    flex: 1;
    text-align: center;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

export const CustomSkeleton = styled.div`
  .item {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    .ant-skeleton-button {
      width: 100%;
      margin-bottom: 10px;
      max-height: 20px;
    }
    .ant-skeleton {
      &:nth-of-type(1) {
        width: 50%;
      }
      &:nth-of-type(2) {
        width: 80%;
      }
      &:nth-of-type(3) {
        width: 60%;
      }
    }
  }
`;
